<template>
  <dr-row class="down-item" justifyContent="space-between" alignItems="center" @click="pdfItemClick(pdfObj)">
    <van-icon name="static/imgs/pdf-icon.png" size="33" />
    <div class="down-title">{{pdfObj.name}}</div>
  </dr-row>
</template>

<script>
export default {
  props:{
    pdfObj:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },
  data() {
    return {
      
    }
  },
  methods:{
    pdfItemClick (item) {
      if (item.url) {
        this.$router.push({ path: '/previewPdf', query: { url: this.getImageUrl(item.url) } })
      } else {
        this.$toast('文件资源获取失败，无法预览');
      }
    },
  }
}
</script>

<style scoped>
.down-item {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #eeeeee;
}
.down-title {
  width: 85%;
  font-size: 13px;
  color: #333333;
}
.down-btn {
  border: 1px solid #0071ee;
  padding: 3px 7px;
  border-radius: 30px;
  color: #0071ee;
}
</style>


// WEBPACK FOOTER //
// src/components/pdf/index.vue